var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
import React, { useRef, useState, useEffect, useCallback } from "react";
import videojs from "video.js";
const useVideoJS = function (videoJsOptions) {
  let classNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  const videoNode = useRef(null);
  const [ready, setReady] = useState(false);
  const changedKey = JSON.stringify(videoJsOptions);
  const player = useRef(null);
  useEffect(() => {
    if (!videoNode.current) return;
    player.current = videojs(videoNode.current, videoJsOptions);
    player.current.ready(() => {
      setReady(true);
    });
    return () => {
      var _a;
      (_a = player.current) == null ? void 0 : _a.dispose();
    };
  }, [changedKey]);
  const Video = useCallback(_a => {
    var _b = _a,
      {
        children
      } = _b,
      props = __objRest(_b, ["children"]);
    return /* @__PURE__ */React.createElement("div", {
      "data-vjs-player": true,
      key: changedKey
    }, /* @__PURE__ */React.createElement("video", __spreadValues({
      ref: videoNode,
      className: `video-js ${classNames}`
    }, props), children));
  }, [changedKey]);
  return {
    Video,
    ready,
    player: player.current
  };
};
export { useVideoJS };